import { isEmpty } from "lodash-es";
import { ensure, ensureArray, stringType, TType } from "types";

import { IURLSearchParams, urlSearchParamsConfig } from "@/core/url";
import { codelistType, ICodelist } from "@/data/codelists";

export interface IAssignmentsURLFilter {
  status?: Array<ICodelist>;
  query?: string;
  startDateArray?: string;
  endDateArray?: string;
  contactPersonId?: Array<number>;
}

const configAssignmentsURLFilterType: TType<IAssignmentsURLFilter> = {
  query: stringType(undefined),
  status: v => (isEmpty(v) ? undefined : ensureArray(codelistType)(v)),
  startDateArray: v => (v ? v : undefined),
  endDateArray: v => (v ? v : undefined),
  contactPersonId: v => (!isEmpty(v) ? v : undefined),
};

export const assignmentsURLFilterType = ensure(configAssignmentsURLFilterType);

interface IAssignmentsListSearchParams extends IURLSearchParams {
  filtersConfig: IAssignmentsURLFilter;
}

const configAssignmentsListSearchParams: TType<IAssignmentsListSearchParams> = {
  ...urlSearchParamsConfig,
  filtersConfig: assignmentsURLFilterType,
};

export const assignmentsListSearchParamsType = ensure(configAssignmentsListSearchParams);
